import React from "react"
import { useRouter } from "next/router"
import Link from "next/link"
import Image from "next/legacy/image"
// Components
import Loader from "@/components/newLoader/Loader"
import Header from "@/components/newHeader/Header"
import Footer from "@/components/newFooter/newFooter"
// Styles
import styles from "./mission.module.scss"
import { ROBOTS_META } from "const"
import BasicHeadSeo from "@/components/basicHeadSeo"

export default function Mission() {
  const router = useRouter()

  return (
    <>
      <BasicHeadSeo
        title="Our Mission | MawooPets.com"
        description="Our mission is to bring pets from vetted breeders to forever homes, and ensure no pet ends up in a shelter. Read our mission, and what we are doing to make it a reality."
        image={`${process.env.NEXT_PUBLIC_ROOT_URL}/mawoo_social_1600x906.png`}
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/mission`}
        content={ROBOTS_META}
      />

      <main className={styles.main}>
        {router.isFallback && (
          <div className={styles.loader}>
            <Loader theme="tall" />
          </div>
        )}

        <Header />
        <div className={styles.content}>
          <section className={styles.grid}>
            <div className={styles.containerImage}>
              <div className={styles.imageDesktop}>
                <Image
                  src="/mission/img/desktop/landing.png"
                  alt="Lady lying on bed smiling with a brown dachshund puppy on her stomach with its tongue out"
                  layout="responsive"
                  width={350}
                  height={450}
                  quality={100}
                  objectFit="fill"
                />
              </div>
              <div className={styles.imageMobile}>
                <Image
                  src="/mission/img/mobile/landing.png"
                  alt="Lady lying on bed smiling with a brown dachshund puppy on her stomach with its tongue out"
                  layout="responsive"
                  width={500}
                  height={250}
                  quality={100}
                  objectFit="fill"
                />
              </div>
            </div>
            <div className={styles.containerText}>
              <div className={styles.heartIcon} />
              <h2>Our Mission</h2>
              <h1>
                Creating a future where every pet has a home, and every home has
                a pet.
              </h1>
              <p>
                Our calling is to bring pets into people's homes, and to ensure
                that no pet ends up in a shelter. To realize this vision, we
                work every day to make pet adoption a joyful experience, and to
                promote the highest standards of breeding. <br />
                <br />
                Our support doesn't end with finding your pet. We provide
                consistent support beyond your adoption, ensuring that your
                journey as a pet parent is a fulfilling. Click below to learn
                more about the journey we are on.
              </p>
              <div className={styles.sectionBtn}>
                <Link href="/our-approach" className={styles.learnMore}>
                  <button className={styles.learnMore}> Learn More</button>
                </Link>
                <Link href="/search" className={styles.browse}>
                  {" "}
                  <button className={styles.browse}>Browse Puppies</button>
                </Link>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </main>
    </>
  )
}
